firebird.factory('videoPopoutService', [
    '$timeout',
    '$window',
    'logService',
    'helperService',
    'meetingService',
    'configService',
    'videoGlobalService',
    function ($timeout, $window, logService, helperService, meetingService, configService, videoGlobalService) {
        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoPopoutService');

        var service = {
            initialize: initialize
        };

        var self;

        return service;

        function initialize(selfParam) {
            self = selfParam;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            // whether to allow popout of videos
            self.layoutPopout = false;

            // layout popout feature
            self.popoutData = {
                windows: {}, // index is id or '*', and value is window object.
                width: 320,
                height: 180,
                minWidth: 80
            };

            self.initPopout = initPopout;
            self.popoutAddOne = popoutAddOne;
            self.popoutRemoveOne = popoutRemoveOne;
            self.onPopoutUpdateDisplayed = onPopoutUpdateDisplayed;
            self.onPopoutAllVideos = onPopoutAllVideos;
            self.onPopoutOneVideo = onPopoutOneVideo;
            self.onPopoutCreateVideo = onPopoutCreateVideo;
            self.onPopoutRemoveVideo = onPopoutRemoveVideo;
            self.onPopoutEnableVideo = onPopoutEnableVideo;
            self.onPopoutLeaveConf = onPopoutLeaveConf;
            self.getPopoutVideoSize = getPopoutVideoSize;
        }

        // update from config
        function initPopout() {
            var layoutPopout = configService.getClientValue('layoutPopout') || null;
            self.layoutPopout = layoutPopout == 'true';
        }

        function popoutAddOne(popout, id) {
            var video1 = $window.$('#videoroom-videos > div[user="' + id + '"] > video').get(0);
            var video2 = popout.document.querySelector('div[user="' + id + '"] > video');
            video2.srcObject = video1.srcObject;

            var div1 = video1.parentNode,
                div2 = video2.parentNode;
            div1.setAttribute('enable', 'false');
            div1.setAttribute('popout', 'true');

            if (self.hasTestLayout) {
                var objectFit = (div1.className || '').match(/\bscreen\b/) ? 'contain' : 'cover';
                div2.style.backgroundSize = objectFit;
                div2.style.backgrounRepeat = 'no-repeat';
                div2.style.backgroundPosition = 'center';
                video2.style.display = 'none';
                var testdiv = div1.querySelector('div.testlayout');
                if (testdiv) {
                    div2.style.backgroundImage = testdiv.style.backgroundImage;
                } else {
                    // this may be called from createVideoElement,
                    // but onTestLayoutAddVideo adds testlayout afterwards.
                    $timeout(function () {
                        var testdiv = div1.querySelector('div.testlayout');
                        if (testdiv) {
                            div2.style.backgroundImage = testdiv.style.backgroundImage;
                        }
                    }, 1000);
                }
            }
        }

        function popoutRemoveOne(popout, id) {
            var video1 = $window.$('#videoroom-videos > div[user="' + id + '"] > video').get(0);

            var div1 = video1.parentNode;
            div1.setAttribute('enable', 'true');
            div1.removeAttribute('popout');
        }

        // called for layoutPage and layoutPopout to hide popped out videos.
        function onPopoutUpdateDisplayed(videoDivs, input, output) {
            if (!self.layoutPopout || !self.layoutPage) {
                return input.length;
            }

            for (var i = videoDivs.length - 1; i >= 0; --i) {
                var div1 = videoDivs[i];
                if (div1.getAttribute('popout')) {
                    videoDivs.splice(i, 1);
                    input.splice(i, 1);
                    if (self.layoutPageData.layout == 'allhands') {
                        output.splice(i, 1);
                    }
                    div1.setAttribute('enable', 'false');
                    div1.setAttribute(
                        'style',
                        'left: 0px; top: 0px; width: 0px; height: 0px; display: none; visibility: hidden;'
                    );
                }
            }
            return input.length;
        }

        // popout one video
        function onPopoutOneVideo(id, div) {
            if (!self.layoutPopout) {
                logger.warn('onPopoutOneVideo', 'popout feature is not enabled');
                self.showAlert(
                    'Error',
                    !self.layoutPopout
                        ? 'This feature is not enabled. Please enable this first.'
                        : 'This feature is only available in a browser.'
                );
                return;
            }

            logService.log('videoroomCtrl - popout one video for ' + id);
            if (self.popoutData.windows[id] === undefined) {
                var width = self.popoutData.width * 3,
                    height = self.popoutData.height * 3;
                var left = Math.round(($window.screen.availWidth || 1280) / 2 - width / 2),
                    top = Math.round(($window.screen.availHeight || 720) / 2 - height / 2);
                var popout = $window.open(
                    '',
                    helperService.isElectron() ? 'native:child' : undefined,
                    'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top
                );
                self.popoutData.windows[id] = popout;

                var head =
                    '<title>' +
                    div.getAttribute('displayname') +
                    '</title>\n' +
                    '<style type="text/css">\n' +
                    'body > div { position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; }\n' +
                    'video { width: 100%; height: 100%; background-color: black; object-fit: contain; }\n' +
                    '</style>';
                popout.document.head.innerHTML = head;

                var html =
                    '<div style="" user="' +
                    id +
                    '"><video style="' +
                    (id == self.attendantId ? ' transform: scaleX(-1);' : '') +
                    '" autoplay muted /></div>';
                popout.document.body.innerHTML = html;

                self.popoutAddOne(popout, id);
                self.updateVideosLayout();

                popout.onbeforeunload = function () {
                    var popout = self.popoutData.windows[id];
                    delete self.popoutData.windows[id];
                    self.popoutRemoveOne(popout, id);
                    self.updateVideosLayout();
                };
            } else {
                var w = self.popoutData.windows[id];
                delete self.popoutData.windows[id];
                w.close();
            }
        }

        // popout all videos
        function onPopoutAllVideos() {
            if (!self.layoutPopout) {
                logger.warn('onPopoutAllVideos', 'popout feature is not enabled');
                self.showAlert(
                    'Error',
                    !self.layoutPopout
                        ? 'This feature is not enabled. Please enable this first.'
                        : 'This feature is only available in a browser.'
                );
                return;
            }

            logService.log('videoroomCtrl - popout all videos');
            if (self.popoutData.windows['*'] === undefined) {
                var divs = $window.$('#videoroom-videos > div[enable="true"]');
                if (self.layoutPage) {
                    divs = $window.$('#videoroom-videos > div[user]');
                }
                var width0 = self.popoutData.width,
                    height0 = self.popoutData.height;
                var width = width0,
                    height = $window.screen.availHeight || 720,
                    left = $window.screen.availWidth - width0;
                var popout = $window.open(
                    '',
                    helperService.isElectron() ? 'native:child' : undefined,
                    'width=' + width + ',height=' + height + ',left=' + left
                );

                self.popoutData.windows['*'] = popout;

                var head =
                    '<title>Meeting: ' +
                    meetingService.getMeetingCode() +
                    '</title>\n' +
                    '<style type="text/css">\n' +
                    'body > div { position: absolute; left: 0px; right: 0px; top: 0px; bottom: 0px; display: flex; flex-flow: row wrap; justify-content: flex-start; align-content: flex-start; align-items: flex-start; }\n' +
                    'body > div:empty:after { content: "No videos"; position: absolute; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; font-family: sans-serif; color: grey; font-size: 20px; }\n' +
                    'div[user] { position: relative; display: inline-block; }\n' +
                    'video { width: 100%; height: 100%; background-color: black; }\n' +
                    '</style>';
                popout.document.head.innerHTML = head;

                var users = divs.toArray().map(function (div) {
                    return div.getAttribute('user');
                });
                var html =
                    '<div>' +
                    users
                        .map(function (id) {
                            var div = $window.$('#videoroom-videos > div[user="' + id + '"]').get(0);
                            var objectFit = (div.className || '').match(/\bscreen\b/) ? 'contain' : 'cover';
                            return (
                                '<div style="width: ' +
                                width0 +
                                'px; height: ' +
                                height0 +
                                'px;" user="' +
                                id +
                                '">' +
                                '<video style="object-fit: ' +
                                objectFit +
                                ';' +
                                (id == self.attendantId ? ' transform: scaleX(-1);' : '') +
                                '" autoplay muted /></div>'
                            );
                        })
                        .join('\n') +
                    '</div>';
                popout.document.body.innerHTML = html;
                users.forEach(function (id) {
                    self.popoutAddOne(popout, id);
                });
                self.updateVideosLayout();

                popout.document.body.onresize = function () {
                    var size = self.getPopoutVideoSize(popout);
                    [].slice.call(popout.document.querySelectorAll('div[user]')).forEach(function (div) {
                        div.style.width = size.width + 'px';
                        div.style.height = size.height + 'px';
                    });
                };
                popout.onbeforeunload = function () {
                    var popout = self.popoutData.windows['*'];
                    delete self.popoutData.windows['*'];
                    var users = [].slice.call(popout.document.querySelectorAll('div[user]')).map(function (div) {
                        return div.getAttribute('user');
                    });
                    users.forEach(function (id) {
                        self.popoutRemoveOne(popout, id);
                    });
                    self.updateVideosLayout();
                };
            } else {
                var w = self.popoutData.windows['*'];
                delete self.popoutData.windows['*'];
                w.close();
            }
        }

        // video is added or enabled.
        function onPopoutCreateVideo(id, div, created) {
            if (!self.layoutPopout) {
                logger.warn('onPopoutCreateVideo', 'popout feature is not enabled');
                return;
            }

            if (div.getAttribute('enable') != 'true') {
                logService.log('videoroomCtrl - popout not checked since video not enabled');
                return;
            }

            if (self.popoutData.windows['*'] !== undefined) {
                logService.log('videoroomCtrl - popout create for ' + id);
                var popout = self.popoutData.windows['*'];
                var div0 = popout.document.createElement('div');
                var size = self.getPopoutVideoSize(popout);
                div0.setAttribute('style', 'width: ' + size.width + 'px; height: ' + size.height + 'px;');
                div0.setAttribute('user', id);
                var objectFit = (div.className || '').match(/\bscreen\b/) ? 'contain' : 'cover';
                div0.innerHTML =
                    '<video style="object-fit: ' +
                    objectFit +
                    ';' +
                    (id == self.attendantId ? ' transform: scaleX(-1);' : '') +
                    '" autoplay muted />';
                popout.document.querySelector('body > div').appendChild(div0);
                self.popoutAddOne(popout, id);
                ////caller will call this already. no need here.
                //self.updateVideosLayout();
            }
        }

        // single video size when all videos are popped out.
        function getPopoutVideoSize(popout) {
            var ratio = 16 / 9;
            var width;
            if (popout.innerWidth > 640) {
                var count = Math.floor(popout.innerWidth / self.popoutData.width);
                width = Math.floor(popout.innerWidth / count);
            } else {
                width = Math.max(self.popoutData.minWidth, popout.innerWidth);
            }
            var height = Math.round(width / ratio);
            return { width: width, height: height };
        }

        // video is removed or disabled.
        function onPopoutRemoveVideo(id, div) {
            if (!self.layoutPopout) {
                logger.warn('onPopoutRemoveVideo', 'popout feature is not enabled');
                return;
            }

            if (self.popoutData.windows[id] !== undefined) {
                logService.log('videoroomCtrl - popout remove for ' + id);
                // this will cause the external popout to close on reconnection/republish.
                var w = self.popoutData.windows[id];
                delete self.popoutData.windows[id];
                w.close();
            } else if (self.popoutData.windows['*'] !== undefined) {
                logService.log('videoroomCtrl - popout remove for ' + id);
                var popout = self.popoutData.windows['*'];
                var div0 = popout.document.querySelector('div[user="' + id + '"]');
                if (div0) {
                    div0.parentNode.removeChild(div0);
                    ////caller will already remove the div element. no need for this.
                    //var video1 = $window.$('#videoroom-videos > div[user="' + id + '"] > video').get(0);
                    //video1.parentNode.setAttribute('enable', 'true');
                    //self.updateVideosLayout();
                }
            }
        }

        // helper function to  call create or remove when enable is changed.
        function onPopoutEnableVideo(id, div, enable) {
            if (enable) {
                self.onPopoutCreateVideo(id, div, false);
            } else {
                self.onPopoutRemoveVideo(id, div);
            }
        }

        // leave conf, close all external windows.
        function onPopoutLeaveConf() {
            if (self.layoutPopout) {
                for (var id in self.popoutData.windows) {
                    var win = self.popoutData.windows[id];
                    if (win) {
                        logService.log('videoroomCtrl - force close popout window for ' + id);
                        delete self.popoutData.windows[id];
                        win.close();
                    }
                }
            }
        }
    }
]);
